import React, { FunctionComponent, useEffect } from 'react'
import { IVerifyPassword } from '../../domain/usecases/VerifyPassword'
import CartaoNew from '../components/CartaoNew'
import ConsultaBoleto from './components/ConsultaBoleto'
import DetalhesPagamentoBoleto from './components/DetalhePagamentoBoleto'
import ContainerPagePayments from '../components/ContainerPagePayments'
import { usePagamentoBoleto } from '../../hooks/usePagamentoBoleto'
import { useHistory } from 'react-router-dom'
import { useCartao } from '../../hooks/useCartao'
import { isValidValue } from '../../../../shared/utils/validates'
import PagamentoRoutes from '../../utils/PagamentoRoutes'
import { IEnviarPinTmovPay } from 'modules/pagamentos/domain/usecases/EnviarPinTmovPay'
import { IValidarPinTmovPay } from 'modules/pagamentos/domain/usecases/ValidarPinTmovPay'

interface PagamentoBoletoProp {
  verifyPassword: IVerifyPassword
  enviarPinTmovPay: IEnviarPinTmovPay
  validarPinTmovPay: IValidarPinTmovPay
}

export enum StepPagamentoBoleto {
  PAGAMENTO_CONSULTAR_BOLETO,
  PAGAMENTO_DETALHES_BOLETO,
}
const PagamentoBoleto: FunctionComponent<PagamentoBoletoProp> = ({
  verifyPassword,
  enviarPinTmovPay,
  validarPinTmovPay,
}) => {
  const { step, voltar, limpar } = usePagamentoBoleto()
  const history = useHistory()
  const { cartao } = useCartao()
  const component = {
    [StepPagamentoBoleto.PAGAMENTO_CONSULTAR_BOLETO]: <ConsultaBoleto />,
    [StepPagamentoBoleto.PAGAMENTO_DETALHES_BOLETO]: (
      <DetalhesPagamentoBoleto
        verifyPassword={verifyPassword}
        enviarPinTmovPay={enviarPinTmovPay}
        validarPinTmovPay={validarPinTmovPay}
      />
    ),
  }

  useEffect(() => {
    limpar()
  }, [])

  useEffect(() => {
    if (!isValidValue(cartao)) {
      history.replace(PagamentoRoutes.PAGAMENTO, {
        reloadHomePagamento: false,
      })
    }
  }, [cartao])

  return (
    <ContainerPagePayments
      header={<CartaoNew onGoBack={step ? voltar : undefined} />}
      breadCrumb="Pagamentos/Pagar boleto"
    >
      {component[step]}
    </ContainerPagePayments>
  )
}

export default PagamentoBoleto
